import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/common';
import { API_ENDPOINT } from '@core/configs';

@Injectable({
  providedIn: 'root',
})
export class NoSendListService {
  constructor(
    private readonly http: ApiService
  ) {
  }

  sendInQueue(data: { allowSendList: number[], excludeSendList: number[] }) {
    return this.http.post(
      API_ENDPOINT.noSendList.controller + API_ENDPOINT.noSendList.excludeSend,
      data,
    );
  }
}
